'use client'

import { usePathname } from 'next/navigation'
import { isSensitiveAnalyticsPathname } from '@/utils/analyticsUrl'
import { useAnalyticsPreferences } from './AnalyticsPreferencesContext'

export default function AnalyticsPreferencesButton({ label = 'Cookies' }: { label?: string }) {
  const pathname = usePathname()
  const { preferencesOpen, openPreferences } = useAnalyticsPreferences()
  if (isSensitiveAnalyticsPathname(pathname)) return null

  return (
    <button
      type="button"
      onClick={openPreferences}
      aria-expanded={preferencesOpen}
      aria-controls="analytics-preferences-dialog"
      className="block py-1.5 text-gray-600 transition-colors duration-200 hover:text-forest"
    >
      {label}
    </button>
  )
}
